<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-envelope-o"></i> Informations de contact
    </div>
    <div class="card-block">
      <dl class="row">
        <dt class="col-sm-4">Email</dt>
        <dd class="col-sm-8">
          <el-input
            v-if="checkPermission"
            v-model="contactInfo.email"
            type="email"
            autosize
            :class="{
              'has-error': !contactInfo.email,
            }"
            @change="editClient('contactInfo.email', $event.trim())"
            @blur="handleBlur"
          />
          <span v-else>{{ contactInfo.email }}</span>
        </dd>
        <dt class="col-sm-4">
          Infos
          <i
            class="fa fa-info-circle ml-05"
            v-tooltip="{
              content:
                'Informations visibles par le coach (horaires pour appeler, nom et téléphone du contact...)',
              placement: 'top',
            }"
          ></i>
        </dt>
        <dd class="col-sm-8">
          <el-input
            v-if="checkPermission"
            v-model="contactInfo.notes"
            autosize
            type="textarea"
            :class="{
              'has-error': !contactInfo.notes,
            }"
            @change="editClient('contactInfo.notes', $event.trim())"
            @blur="handleBlur"
          />
          <span v-else>{{ contactInfo.notes }}</span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      contactInfo: {
        email: this.client.contactInfo?.email || "",
        notes: this.client.contactInfo?.notes || "",
      },
    };
  },

  computed: {
    checkPermission() {
      return (
        this.hasPermission(this.$store.state.user, "CLIENTS_WRITE") &&
        !this.client.deletedAt
      );
    },
  },

  methods: {
    editClient(name, value) {
      this.$emit("edit", { name, value });
    },

    handleBlur() {
      if (!this.contactInfo.email || !this.contactInfo.notes) {
        this.$errorToast(
          "Veuillez remplir les champs obligatoires (entourés en rouge)",
        );
      }
    },
  },
};
</script>
